import React, { useEffect, useState, useRef } from "react";
import HomeDefaultDealOfDay from "./HomeDefaultDealOfDay";
import PageContainer from "../../components/layouts/PageContainer";
import HeaderMarketPlace from "../../components/shared/headers/HeaderMarketPlace";
import HeaderMobile from "../../components/shared/headers/HeaderMobile";
import FooterMarketPlace2 from "../../components/shared/footers/FooterMarketPlace2";
import { Link, useNavigate } from "react-router-dom";
import clearSale from "../../assets/static/img/clearSale.png";
import clearSaleMobile from "../../assets/static/img/Clear_Sale_Mobile.png";
import Brand1 from "../../assets/static/img/brand-1.png";
import Brand2 from "../../assets/static/img/brand-2.png";
import Brand3 from "../../assets/static/img/brand-3.png";
import Brand5 from "../../assets/static/img/brand-5.png";
import TopCategories from "./TopCategories";
import CTASection from "./CTASection";
import Banner1 from "../../assets/static/img/category/Banner (2).jpg";
import axios from "axios";
import config from "../../config";
import { Helmet } from "react-helmet";
import ClosingSaleBanner from "../../components/ClosingSaleBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const HomeMarketPlacePage = () => {
  const navigate = useNavigate();
  const slide1Ref = useRef(null);
  const [slideHeight, setSlideHeight] = useState("500px");

  const headers = (
    <>
      <HeaderMarketPlace />
      <HeaderMobile />
    </>
  );
  const footer = <FooterMarketPlace2 />;

  const [image, setImages] = useState([]);

  useEffect(() => {
    const fetchImage = async () => {
      const formData = new FormData();
      formData.append("type", 1);
      try {
        await axios({
          method: "post",
          data: formData,
          url: `${config.apiUrl}/offer_image`,
          headers: {
            Accept: "application/json",
          },
        }).then((res) => {
          setImages(res.data.data);
        });
      } catch (error) {
        console.log(error);
      }
    };
    if (image?.length == 0) {
      fetchImage();
    }
  }, []);

  // Measure the ClosingSaleBanner height after render and sync all slides
  useEffect(() => {
    const measureHeight = () => {
      if (slide1Ref.current) {
        const h = slide1Ref.current.offsetHeight;
        if (h > 0) setSlideHeight(`${h}px`);
      }
    };
    measureHeight();
    window.addEventListener("resize", measureHeight);
    return () => window.removeEventListener("resize", measureHeight);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Quality Building Materials in London & Harrow | W-hanson UK
        </title>
        <meta
          name="description"
          content="Discover top-quality building materials at W-hanson UK. Buy building supplies in London and Harrow. Find everything you need for your construction projects."
        />
        <meta
          name="keywords"
          content="building materials, buy building materials,building materials near me,building materials london,building supplies london,building materials harrow"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "W-hanson",
            "url": "https://www.w-hanson.co.uk",
            "potentialAction": {
              "@type": "SearchAction",
              "target":
                "https://www.w-hanson.co.uk/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "W-Hanson",
            "url": "https://www.w-hanson.co.uk/",
            "logo":
              "https://www.w-hanson.co.uk/static/media/w-hanson-logo-white.0667952180954ffdffa5.png",
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "020 8864 0822",
                "contactType": "sales",
                "areaServed": "GB",
                "availableLanguage": "en"
              },
              {
                "@type": "ContactPoint",
                "telephone": "020-8845-2173",
                "contactType": "customer service",
                "areaServed": "GB",
                "availableLanguage": "en"
              },
              {
                "@type": "ContactPoint",
                "telephone": "020-8571-3161",
                "contactType": "package tracking",
                "areaServed": "GB",
                "availableLanguage": "en"
              }
            ],
            "sameAs": [
              "https://www.facebook.com/whansonharrow/",
              "https://www.instagram.com/whansonharrow/"
            ]
          })}
        </script>
      </Helmet>
      <PageContainer header={headers} footer={footer} title="Home Market Place">
        <main id="homepage-3">
          <section className="mt-50 mobile-mt">
            <style>{`
              /* ===== HERO SWIPER GLOBAL STYLES ===== */

              /* Container */
              .hero-swiper-wrap {
                position: relative;
                width: 100%;
                overflow: hidden;
                // box-shadow: 0 6px 32px rgba(0, 0, 0, 0.14);
              }

              .hero-swiper {
                position: relative;
                z-index: 0;
                width: 100%;
              }

              /* ---- Every slide: same height, no overflow ---- */
              .hero-swiper .swiper-wrapper {
                align-items: stretch;
              }

              .hero-swiper .swiper-slide {
                height: ${slideHeight} !important;
                min-height: ${slideHeight} !important;
                max-height: ${slideHeight} !important;
                overflow: hidden;
                position: relative;
                display: flex;
                align-items: stretch;
              }

              /* ---- Slide 1: ClosingSaleBanner fills completely ---- */
              .hero-swiper .closing-slide-wrap {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: stretch;
              }
              .hero-swiper .closing-slide-wrap > * {
                flex: 1;
                width: 100% !important;
                height: 100% !important;
                min-height: 100% !important;
                max-height: 100% !important;
                margin: 0 !important;
                padding-top: 0 !important;
                padding-bottom: 0 !important;
              }

              /* ---- Slides 2, 3, 4: image link fills slide ---- */
               .hero-swiper .img-slide-link {
                display: block;
               /* Set the specific width you want all banners to follow */
                width: 98%; 
               /* 'auto' on left/right margins centers the 90% wide box */
               margin: 0 auto; 
               height: 100%;
               line-height: 0;
               overflow: hidden;
 
  
                /* Background Image Settings to prevent stretching */
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                }

               .hero-swiper .slide-img {
                display: block;
                width: 100%;
                height: 100%;
                background-size: cover;      /* Fills the div without stretching */
                background-position: center; /* Keeps the middle of the image visible */
                background-repeat: no-repeat;
                border-radius: 15px;
                }

              /* ---- Navigation arrows ---- */
              .hero-swiper .swiper-button-prev,
              .hero-swiper .swiper-button-next {
                z-index: 25;
                width: 46px;
                height: 46px;
                background: rgba(255, 255, 255, 0.93);
                border-radius: 50%;
                box-shadow: 0 3px 14px rgba(0, 0, 0, 0.2);
                color: #1a1a1a !important;
                top: 40%;
                transform: translateY(-50%);
                transition: background 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;
                margin-top: 0;
              }
              .hero-swiper .swiper-button-prev { left: 16px; }
              .hero-swiper .swiper-button-next { right: 16px; }
              .hero-swiper .swiper-button-prev:hover,
              .hero-swiper .swiper-button-next:hover {
                background: #ffffff;
                transform: translateY(-50%) scale(1.1);
                box-shadow: 0 6px 22px rgba(0, 0, 0, 0.25);
              }
              .hero-swiper .swiper-button-prev::after,
              .hero-swiper .swiper-button-next::after {
                font-size: 15px;
                font-weight: 900;
              }

              /* ---- Pagination dots ---- */
              .hero-swiper .swiper-pagination {
                bottom: 14px;
                z-index: 25;
              }
              .hero-swiper .swiper-pagination-bullet {
                width: 10px;
                height: 10px;
                background: rgba(255, 255, 255, 0.55);
                opacity: 1;
                transition: all 0.3s ease;
              }
              .hero-swiper .swiper-pagination-bullet-active {
                background: #ffffff;
                width: 30px;
                border-radius: 5px;
              }

              /* In your style tag */
.desktop-img { display: block  !important; }
.mobile-img  { display: none  !important;  }

@media (max-width: 768px) {
  .desktop-img { display: none  !important;  }
  .mobile-img  { display: block  !important; }
}

@media (max-width: 768px) {
  .desktop-img { display: none  !important;  }
  .mobile-img  { display: block  !important; }
}

              /* ---- Mobile ---- */
              @media (min-width: 1440px) {
                .hero-swiper .swiper-slide {
                  height: 600px !important;
                  min-height: 600px !important;
                  max-height: 600px !important;
                }
              }
              @media (max-width: 768px) {
                .hero-swiper .swiper-slide {
                  height: 200px !important;
                  min-height: 200px !important;
                  max-height: 200px !important;
                }
                .hero-swiper .swiper-button-prev,
                .hero-swiper .swiper-button-next {
                  width: 32px;
                  height: 32px;
                }
                .hero-swiper .swiper-button-prev::after,
                .hero-swiper .swiper-button-next::after {
                  font-size: 11px;
                }
              }
            `}</style>

            <div className="hero-swiper-wrap">
              <Swiper
                className="hero-swiper"
                modules={[Autoplay, Pagination, Navigation]}
                autoplay={{ delay: 10000, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                navigation={false}
                loop={true}
                speed={700}
              >
                {/* Slide 1 — ClosingSaleBanner component (sets height reference) */}
                <SwiperSlide>
                  <Link to="/clearance" className="img-slide-link">
                    {/* Desktop image */}
                    <img
                      src={clearSale}
                      loading="lazy"
                      alt="Clearance Sale"
                      className="slide-img desktop-img"
                    />
                    {/* Mobile image */}
                    <img
                      src={clearSale}
                      loading="lazy"
                      alt="Clearance Sale"
                      className="slide-img mobile-img "
                      style={{
                        width: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                    />
                  </Link>
                </SwiperSlide>

                {/* Slide 2 — Clearance Sale */}
                {image?.clearance && (
                  <SwiperSlide>
                    <Link to="/offers" className="img-slide-link">
                      <img
                        src={image.clearance}
                        loading="lazy"
                        alt="Clearance Sale"
                        className="slide-img"
                      />
                    </Link>
                  </SwiperSlide>
                )}

                {/* Slide 3 — June Deals */}
                {image?.offer && (
                  <SwiperSlide>
                    <Link to="/offers" className="img-slide-link">
                      <img
                        src={image.offer}
                        loading="lazy"
                        alt="June Deals"
                        className="slide-img"
                      />
                    </Link>
                  </SwiperSlide>
                )}

                {/* Slide 4 — Bespoke Machine Service */}
                <SwiperSlide>
                  <Link
                    to="/bespoke-machine-service"
                    className="img-slide-link"
                  >
                    <img
                      src={Banner1}
                      loading="lazy"
                      alt="Bespoke Machine Service"
                      className="slide-img resp-banner"
                    />
                  </Link>
                </SwiperSlide>
              </Swiper>
            </div>
          </section>

          <TopCategories />
          <CTASection image={image} />
          <HomeDefaultDealOfDay collectionSlug="deal-of-the-day" />

          <div className="pt-70 pb-50">
            <div className="ps-best-sale-brands ps-section--furniture pt-10">
              <div className="container">
                <div className="ps-section__header">
                  <h3>BEST SELLER BRANDS</h3>
                </div>
                <div className="ps-section__content">
                  <ul className="ps-image-list">
                    <li className={"px-4 py-5"} style={{ minWidth: "33.33%" }}>
                      <a>
                        <img
                          src={Brand1}
                          loading="lazy"
                          alt="No Img"
                          width="200"
                        />
                      </a>
                    </li>
                    <li className={"px-4 py-5"} style={{ minWidth: "33.33%" }}>
                      <a>
                        <img
                          src={Brand2}
                          loading="lazy"
                          alt="No Img"
                          width="200"
                        />
                      </a>
                    </li>
                    <li className={"px-4 py-5"} style={{ minWidth: "33.33%" }}>
                      <a>
                        <img
                          src={Brand3}
                          loading="lazy"
                          alt="No Img"
                          width="200"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
      </PageContainer>
    </>
  );
};
export default HomeMarketPlacePage;
